// src/services/axiosClient.js or axiosClient.ts
import axios from "axios";
import { LOCAL_STORAGE_KEYS } from "../constants/Constants";

const axiosClient = axios.create({
  baseURL: `${process.env.REACT_APP_EDUCATION_VIDEO_BASE_URL}/api/`,
  withCredentials: true,
  withXSRFToken: true,
   headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
      }
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 406 || error.response?.status === 401) {
      // Option 1: dispatch logout if using Redux
      
      // Option 2: redirect using window (safe outside React components)
      localStorage.removeItem(LOCAL_STORAGE_KEYS.isLoggedIn);
      if (localStorage.getItem(LOCAL_STORAGE_KEYS.userType) === 'user') {
           window.location.href = '/login';
      }
      else if (localStorage.getItem(LOCAL_STORAGE_KEYS.userType) === 'admin') {
          window.location.href = '/admin/login';
      }
    else{
        window.location.href = '/login';
    }
    }
    else if (error.response?.status === 406) {
      // Option 1: dispatch logout if using Redux
      //TODO: THIS NEED TO BE CEHEKD FOR EACH USER
      
      
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);



export default axiosClient;
